import React, { Suspense, lazy, useState } from 'react';
import { Link } from 'react-router-dom';
import routes from '../../data/routes';

const Menu = lazy(() => import('react-burger-menu/lib/menus/slide'));

const ExternalArrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginLeft: '8px', opacity: 0.6 }}
  >
    <line x1="7" y1="17" x2="17" y2="7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
);

const Hamburger = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="hamburger-container">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="hamburger-toggle-btn"
        aria-label="Toggle Menu"
      >
        {open ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        )}
      </button>
      <Suspense fallback={<></>}>
        <Menu right isOpen={open} onStateChange={(state) => setOpen(state.isOpen)}>
          <ul className="hamburger-ul">
            {routes.map((l) => (
              <li key={l.label}>
                {l.isExternal ? (
                  <a
                    href={l.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setOpen(false)}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <h3 className={l.index ? 'index-li' : ''}>
                      {l.label}
                    </h3>
                    <ExternalArrow />
                  </a>
                ) : (
                  <Link to={l.path} onClick={() => setOpen(false)}>
                    <h3 className={l.index ? 'index-li' : ''}>{l.label}</h3>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </Menu>
      </Suspense>
    </div>
  );
};

export default Hamburger;
